import { DirectiveBinding } from 'vue';
import { checkAuthority } from '@/utils/common';

// 根据权限控制dom显示隐藏，用法：v-authority="dd"，其中dd(String | Array)为数组或是字符串的权限常量
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    if (!binding.value) return;
    const authority = binding.value;
    const some = binding.modifiers?.some ?? false;
    const check = checkAuthority(authority, some ? 'some' : 'every');
    if (!check && el.parentElement) {
      el.parentElement.removeChild(el); // 没有该内容权限
    }
  },
};
